import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT } from '../../common';

export const ActionLink = styled.a.attrs<{ $color: string }>({
  className: createReadableClass({
    component: CLASS_COMPONENT,
    element: 'action-link'
  })
})`
  color: ${({ $color }) => $color};
  cursor: pointer;
  text-decoration: underline;
`;
